import {Injectable} from '@angular/core';

@Injectable({
              providedIn: 'root'
            })
export class ManagedLocaleService {
  public static DEFAULT_LOCALE_FR = 'fr';
  public static MANAGED_LOCALES = [ManagedLocaleService.DEFAULT_LOCALE_FR];


  public static getSimplifiedLocaleOrFrByDefault(locale: string): string {
    const foundLanguage = ManagedLocaleService.MANAGED_LOCALES.filter(managedLanguage => locale.startsWith(managedLanguage))[0];
    if (foundLanguage) {
      return foundLanguage;
    } else {
      return ManagedLocaleService.DEFAULT_LOCALE_FR;
    }
  }
}
